export const getTagSlug = (name: string) => name.toLowerCase().replace(/\s+/g, '-')
